import { fromJS } from 'immutable';

const setPartnerQueryString = (state) => {
  const postParams = state.getIn(
    ['modules', 'axp-card-member-apply-root', 'body'],
    fromJS({})
  ).toJS();
  if (postParams && !(Object.keys(postParams).length === 0)) {
    let queryString = '?';
    const esc = encodeURIComponent;
    queryString += Object.keys(postParams)
      .map((k) => `${esc(k)}=${esc(postParams[k])}`)
      .join('&');
    return queryString;
  }
  return null;
};

export default setPartnerQueryString;
